/* Règles de la plateforme — DS-03 (Bible §20).
   Dated, versioned, advisory. The acknowledgement is never preselected,
   bundled or inherited: the box starts empty on purpose. ?etat=confirme
   renders the acknowledged state the frame draws. */
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Card, Checkbox, KV, Note } from '@/ui'
import { Retour } from './parts'

export default function Regles() {
  const [params] = useSearchParams()
  const [lu, setLu] = useState(params.get('etat') === 'confirme')

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 640 }}>
      <Retour />
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12 }}>
        <h2 className="t-page" style={{ margin: 0 }}>Règles de la plateforme — Google Reviews</h2>
        <span className="f-help" style={{ marginLeft: 'auto' }}>guide v. 2026-08-12</span>
      </div>

      <Card>
        <p className="t-body" style={{ fontSize: 13 }}>
          Ce que dit la plateforme aujourd’hui (résumé daté, sources officielles liées) ·
          ce que l’outil permet techniquement · le choix de présentation qui vous revient
          (révélation pendant/après). Information produit — pas un avis juridique.
        </p>
      </Card>

      <label style={{ display: 'flex', gap: 10, alignItems: 'flex-start', fontSize: 13, lineHeight: 1.55 }}>
        <Checkbox checked={lu} onChange={e => setLu(e.currentTarget.checked)} />
        <span>
          J’ai lu le guide actuel pour <b>Google Reviews</b>. Je confirme être autorisé à
          configurer cet établissement et responsable de la conformité de cette campagne.
          Cette confirmation n’est pas une certification.
        </span>
      </label>

      <KV rows={[['Confirmations enregistrées', 'v. 12/08 — Lyam, 29 août 18:10 · v. 02/06 — 12 juin']]} />

      <Note tone="candour">
        Re-confirmation exigée après&nbsp;: duplication, changement de guide, remplacement d’un
        lien d’avis, changement de moment public, compte à rebours/retour, copie publique,
        réactivation d’urgence.
      </Note>
    </div>
  )
}
